<div class="brand-wrapper">
    <div style="font-size: 40px; font-weight: bold; font-family: Roboto;">DUCAT</div>
</div>
